// frontend/src/QuizPage.js - FINAL (With Previous/Next Navigation)

import React, { useState } from 'react';
import ResultsPage from './ResultsPage';


// This is the new, text-only quizData object for your QuizPage.js

const quizData = [
    {
        question: "It's Saturday morning. What's the ideal scenario for you?",
        answers: [
            { text: "Tackling a home organization project I've been planning all week.", points: { serene: 10, elegant: 5 } },
            { text: "Calling up friends for a spontaneous brunch or get-together.", points: { pragmatic: 15 } },
            { text: "Exploring a new art gallery or an antique market across town.", points: { curator: 15 } },
            { text: "Enjoying the peace and quiet at home with a coffee and a good book.", points: { serene: 15 } }
        ]
    },
    {
        question: "When you're buying an expensive item, what's your decision-making process?",
        answers: [
            { text: "I research extensively to find a timeless, high-quality piece that will last a lifetime.", points: { elegant: 15 } },
            { text: "I look for something that tells a story and is completely unique—I trust my gut feeling.", points: { curator: 15 } },
            { text: "I read reviews to find the most durable, practical, and family-friendly option available.", points: { pragmatic: 15 } },
            { text: "I look for the cleanest design and the most efficient function, avoiding unnecessary features.", points: { serene: 15 } }
        ]
    },
    {
        question: "Which statement about home design resonates most with you?",
        answers: [
            { text: "A home should be a collection of things you love, no matter the rules.", points: { curator: 15 } },
            { text: "A home should be a functional, easy-to-manage space for living.", points: { pragmatic: 15 } },
            { text: "A home should be a calm, orderly sanctuary from the outside world.", points: { serene: 15 } },
            { text: "A home should be an elegant reflection of taste and attention to detail.", points: { elegant: 15 } }
        ]
    },
    {
        question: "How do you plan a vacation?",
        answers: [
            { text: "With a detailed itinerary, booking the best-reviewed places far in advance.", points: { elegant: 15 } },
            { text: "I just book a flight and figure out the rest when I get there.", points: { curator: 10, pragmatic: 5 } },
            { text: "I plan around activities that the whole group or family will enjoy.", points: { pragmatic: 15 } },
            { text: "I choose a peaceful destination where I can truly relax and unplug.", points: { serene: 15 } }
        ]
    },
    {
        question: "You're given an empty wall. Your first instinct is to...",
        answers: [
            { text: "Find one, perfect, high-quality piece of art to be the single focus.", points: { elegant: 15 } },
            { text: "Create a vibrant gallery wall with a mix of photos, posters, and mirrors.", points: { curator: 15 } },
            { text: "Keep it empty for now to maintain a sense of space and calm.", points: { serene: 15 } },
            { text: "Install functional shelving that is both stylish and useful for storage.", points: { pragmatic: 10, serene: 5 } }
        ]
    },
    {
        question: "A friend is coming over. How do you prepare?",
        answers: [
            { text: "I make sure everything is spotless, perfectly arranged, and looks its best.", points: { elegant: 10, serene: 5 } },
            { text: "I create a comfortable, welcoming vibe with good music and lighting.", points: { curator: 10, pragmatic: 5 } },
            { text: "I focus on the food and drinks, ensuring everyone feels welcome and has plenty to enjoy.", points: { pragmatic: 15 } },
            { text: "My home is always tidy and ready for guests, so I don't need to do much.", points: { serene: 15 } }
        ]
    },
    {
        question: "Which of these sounds like the best compliment someone could give your home?",
        answers: [
            { text: "'It feels so unique and full of personality—it's so YOU!'", points: { curator: 15 } },
            { text: "'It's so practical and comfortable. Everything just works perfectly.'", points: { pragmatic: 15 } },
            { text: "'I feel so calm and relaxed in here. It's like a peaceful escape.'", points: { serene: 15 } },
            { text: "'Every piece is so beautiful and well-chosen. The quality is incredible.'", points: { elegant: 15 } }
        ]
    },
    {
        question: "For you, the primary purpose of a living room is...",
        answers: [
            { text: "To be a flexible hub for family, friends, movie nights, and daily life.", points: { pragmatic: 15 } },
            { text: "To be a quiet, organized space for relaxation and unwinding.", points: { serene: 15 } },
            { text: "To be a curated space that showcases my taste and favorite things.", points: { curator: 15 } },
            { text: "To be an elegant and impressive space for hosting guests.", points: { elegant: 15 } }
        ]
    }
];

function QuizPage() {
    // --- NEW STATE MANAGEMENT ---
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [userAnswers, setUserAnswers] = useState({}); // Stores selected answers like { 0: {text, points}, 1: ... }
    const [finalScores, setFinalScores] = useState(null); // Will hold the final score object
    const [isQuizFinished, setIsQuizFinished] = useState(false);

    // --- UPDATED LOGIC ---

    // This function now only records the user's choice for the current question
    const handleAnswerSelect = (answer) => {
        setUserAnswers({
            ...userAnswers,
            [currentQuestionIndex]: answer
        });
    };

    // New navigation functions
    const handleNext = () => {
        if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    };

    const handlePrevious = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    };

    // This function calculates the total score and finishes the quiz
    const handleFinish = () => {
        let finalScoresObj = { serene: 0, elegant: 0, curator: 0, pragmatic: 0 };
        for (const questionIndex in userAnswers) {
            const points = userAnswers[questionIndex].points;
            for (const personality in points) {
                finalScoresObj[personality] += points[personality];
            }
        }
        setFinalScores(finalScoresObj);
        setIsQuizFinished(true);
    };

    
    // --- STYLING (with a new style for selected answers) ---
    const styles = {
        quizContainer: { maxWidth: '800px', margin: 'auto', textAlign: 'center', padding: '1rem' },
        answersContainer: { display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '2rem' },
        answerButton: { padding: '1rem', fontSize: '1rem', textAlign: 'left', cursor: 'pointer', background: '#f9f9f9', border: '2px solid #ddd', borderRadius: '8px', transition: 'all 0.2s' },
        selectedAnswerButton: { padding: '1rem', fontSize: '1rem', textAlign: 'left', cursor: 'pointer', background: '#e0edff', border: '2px solid #007bff', borderRadius: '8px', transition: 'all 0.2s' }, // Style for selected button
        navigationContainer: { display: 'flex', justifyContent: 'space-between', marginTop: '2.5rem' },
        navButton: { padding: '10px 20px', fontSize: '1rem', fontWeight: 'bold', cursor: 'pointer', border: '1px solid #ccc', borderRadius: '5px' },
        progressBar: { marginTop: '2rem', color: '#777' }
    };

    if (isQuizFinished) {
        return <ResultsPage finalScores={finalScores} />;
    }

    const currentQuestion = quizData[currentQuestionIndex];
    const isLastQuestion = currentQuestionIndex === quizData.length - 1;
    const isAnswerSelected = userAnswers[currentQuestionIndex] !== undefined;

    return (
        <div style={styles.quizContainer}>
            <div style={styles.progressBar}>
                Question {currentQuestionIndex + 1} / {quizData.length}
            </div>
            <h2 style={{minHeight: '4em'}}>{currentQuestion.question}</h2>

            <div style={styles.answersContainer}>
                {currentQuestion.answers.map((answer, index) => {
                    const isSelected = userAnswers[currentQuestionIndex]?.text === answer.text;
                    return (
                        <button 
                            key={index} 
                            onClick={() => handleAnswerSelect(answer)}
                            style={isSelected ? styles.selectedAnswerButton : styles.answerButton}
                        >
                            {answer.text}
                        </button>
                    )
                })}
            </div>

            <div style={styles.navigationContainer}>
                <button 
                    onClick={handlePrevious} 
                    disabled={currentQuestionIndex === 0}
                    style={{...styles.navButton, background: currentQuestionIndex === 0 ? '#eee' : 'white'}}
                >
                    Previous
                </button>
                
                {isLastQuestion ? (
                    <button 
                        onClick={handleFinish}
                        disabled={!isAnswerSelected}
                        style={{...styles.navButton, background: isAnswerSelected ? '#28a745' : '#eee', color: isAnswerSelected ? 'white' : 'black'}}
                    >
                        See Results
                    </button>
                ) : (
                    <button 
                        onClick={handleNext}
                        disabled={!isAnswerSelected}
                        style={{...styles.navButton, background: isAnswerSelected ? '#007bff' : '#eee', color: isAnswerSelected ? 'white' : 'black'}}
                    >
                        Next
                    </button>
                )}
            </div>
        </div>
    );
}

export default QuizPage;